import { render, staticRenderFns } from "./OrgInviteModal.vue?vue&type=template&id=16825fef"
import script from "./OrgInviteModal.vue?vue&type=script&lang=js"
export * from "./OrgInviteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports